<div [ngClass]="{post: true, clearfix: isClearfix}">
    <div class="user-block">
        <pf-image
            class="user-image"
            src="assets/img/default-profile.png"
            alt="User"
            width="40"
            height="40"
            [rounded]="true"
        />
        <span class="username">
            <a routerLink="/">Jonathan Burke Jr.</a>
            <a routerLink="/" class="float-right btn-tool">
                <i class="fas fa-times"></i>
            </a>
        </span>
        <span class="description">Shared publicly - 7:30 PM today</span>
    </div>
    <p>
        Lorem ipsum represents a long-held tradition for designers, typographers
        and the like. Some people hate it and argue for its demise, but others
        ignore the hate as they create awesome tools to help create filler text
        for everyone from bacon lovers to Charlie Sheen fans.
    </p>
    <p>
        <a routerLink="/" class="link-black text-sm mr-2">
            <i class="fas fa-share mr-1"></i>
            Share
        </a>
        <a routerLink="/" class="link-black text-sm">
            <i class="far fa-thumbs-up mr-1"></i>
            Like
        </a>
        <span class="float-right">
            <a routerLink="/" class="link-black text-sm">
                <i class="far fa-comments mr-1"></i>
                Comments (5)
            </a>
        </span>
    </p>
    <form class="form-horizontal">
        <div class="input-group input-group-sm mb-0">
            <input
                class="form-control form-control-sm"
                placeholder="Response"
            />
            <div class="input-group-append">
                <button type="submit" class="btn btn-danger">Send</button>
            </div>
        </div>
    </form>
</div>
